module.exports = __webpack_public_path__ + "img/avatar1.480445ce.jpg";